import { useEffect, useState } from "react";
import { Link, useSearchParams } from "react-router-dom";

export default function VerifyEmail() {
  const [params] = useSearchParams();
  const token = params.get("token")?.trim() ?? "";
  const [phase, setPhase] = useState<"loading" | "ok" | "err">("loading");
  const [error, setError] = useState("");

  useEffect(() => {
    if (!token) {
      setPhase("err");
      setError("This page needs a verification link from your email.");
      return;
    }

    let cancelled = false;
    (async () => {
      const res = await fetch(
        `/api/auth/verify-email?token=${encodeURIComponent(token)}`,
        { credentials: "include" },
      );
      const j = (await res.json()) as { ok?: boolean; error?: string };
      if (cancelled) return;
      if (res.ok && j.ok) {
        setPhase("ok");
      } else {
        setPhase("err");
        setError(j.error || "Verification failed.");
      }
    })();

    return () => {
      cancelled = true;
    };
  }, [token]);

  return (
    <div className="layout">
      <main className="layout-main layout-main--narrow">
        <h1>Email verification</h1>
        {phase === "loading" ? (
          <p className="muted">Confirming your address…</p>
        ) : null}
        {phase === "ok" ? (
          <>
            <div className="account-feedback account-feedback--success" role="status">
              <p>Your email is verified. You can sign in now.</p>
            </div>
            <p style={{ marginTop: "1rem" }}>
              <Link to="/login" className="btn btn-primary">
                Go to sign in
              </Link>
            </p>
          </>
        ) : null}
        {phase === "err" ? (
          <>
            <p className="error">{error}</p>
            <p className="muted" style={{ marginTop: "1rem" }}>
              <Link to="/register">Create an account</Link> or{" "}
              <Link to="/login">sign in</Link> if you already verified.
            </p>
          </>
        ) : null}
      </main>
    </div>
  );
}
